<i18n>
{
  "fr": {  
    "indicator-general-follow-up-note": "Note de suivi"
  },
  "en": {  
    "indicator-general-follow-up-note": "Follow-up note"
  }
}
</i18n>
<template>
  <b-tab-item v-if="indicator" class="pt-24px" :value="tabName">
    <template #header>
      {{ $t('indicator-general-follow-up-note') }}
      <tab-dot v-show="hasIndicatorNote" :isSpecific="isSpecific" />
    </template>

    <hr class="mt-0 mb-16px" />

    <prismic-content :doctype="$consts.prismic.DOCUMENT_TYPE_INDICATOR_DETAIL" v-slot="{ content: detailContent }">
      <b-message
        v-if="detailContent && $prismicText(detailContent.followup_note_warning)"
        type="is-warning"
        class="my-24px is-size-7"
      >
        <prismic-rich-text :field="detailContent.followup_note_warning" />
      </b-message>
    </prismic-content>

    <div class="has-max-width-768">
      <notes class="mb-8px" :notes="indicator.notes" :showForm="showForm" />
      <notes-form
        :notes="indicator.notes"
        @onSaveNotes="saveIndicatorNote"
        @toggleShowForm="toggleShowForm"
        :readOnly="readOnly"
      />
    </div>

    <hr class="mb-0 mt-16px" />
  </b-tab-item>
</template>

<script>
import Notes from '@/components/generic/notes'
import NotesForm from '@/components/generic/notes-form'
import PrismicContent from '@/components/prismic/prismic-content'
import TabDot from '@/components/generic/tab-dot'

export default {
  components: {
    Notes,
    NotesForm,
    PrismicContent,
    TabDot
  },
  props: {
    indicator: { type: Object, required: true },
    tabName: { type: String, required: true },
    isSpecific: Boolean,
    readOnly: Boolean
  },
  data() {
    return {
      showForm: false
    }
  },
  computed: {
    hasIndicatorNote() {
      return this.indicator && this.indicator.notes && this.indicator.notes.trim() ? true : false
    }
  },
  methods: {
    saveIndicatorNote(editedNote) {
      this.$emit('onSaveIndicatorNote', editedNote)
    },
    toggleShowForm(show) {
      this.showForm = show
    }
  }
}
</script>